// Sets the --grain-url CSS variable from the bundled paper-grain WebP
// (lossless, 38% smaller than the PNG it replaced) so body::before can
// render it as the global paper-texture overlay. Imported once from
// main.tsx before first paint.
import grainUrl from "@/assets/paper-grain.webp";

if (typeof document !== "undefined") {
  document.documentElement.style.setProperty("--grain-url", `url(${grainUrl})`);
}
